<template>
  <v-dialog
    v-model="dialogCreazioniMultiple"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar dark color="success" dense>
        <v-btn icon dark @click="dialogCreazioniMultiple = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Gestione fatturazione differita</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="dialogCreazioniMultiple = false">
            Chiudi
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-stepper v-model="stepper1" dense flat :alt-labels="altLabels">
        <v-stepper-header>
          <v-stepper-step step="1" editable :complete="stepper1 > 1">
            Filtro DDT
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2" :complete="stepper1 > 2">
            Scelta DDT
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3" editable :complete="stepper1 > 3">
            Filtro Scontrini
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="4" :complete="stepper1 > 4">
            Scelta Scontrini
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="5" :complete="stepper1 > 5">
            Fatturazione
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="6" editable :complete="stepper1 > 6">
            Anteprima
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="7" editable>
            Definitive
          </v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <filtri-ddt @ricerca="onRicercaClienti" />
            <clienti-ddt
              :idsClienti="idsClienti"
              @selezione="onClientiSelezionati"
            />
            <v-btn color="primary" class="mt-3" @click="openSceltaDDT"
              >Scelta DDT</v-btn
            >
          </v-stepper-content>
          <v-stepper-content step="2">
            <scelta-ddt
              :idsClienti="clientiSelezionati"
              :bollettari="bollettari"
              :dateDdt="dateDdt"
              @selezione="onDdtSelezionati"
            />
            <v-btn color="default" class="mr-5 mt-3" @click="stepper1 = 1"
              >Indietro</v-btn
            >
            <v-btn color="primary" class="mt-3" @click="stepper1 = 3"
              >Filtro Scontrini</v-btn
            >
          </v-stepper-content>
          <v-stepper-content step="3">
            <filtro-scontrini @ricerca="onRicercaClientiScontrini" />
            <clienti-ddt
              :idsClienti="idsClientiScontrini"
              @selezione="onClientiScontriniSelezionati"
            />
            <v-btn color="default" class="mr-5 mt-3" @click="stepper1 = 2"
              >Indietro</v-btn
            >
            <v-btn color="primary" class="mt-3" @click="openSceltaScontrini"
              >Scelta Scontrini</v-btn
            >
          </v-stepper-content>
          <v-stepper-content step="4">
            <scelta-scontrini
              :idsClienti="clientiScontriniSelezionati"
              :dateScontrini="dateScontrini"
              @selezione="onScontriniSelezionati"
            />
            <v-btn color="default" class="mr-5 mt-3" @click="stepper1 = 3"
              >Indietro</v-btn
            >
            <v-btn color="primary" class="mt-3" @click="stepper1 = 5"
              >Fatturazione</v-btn
            >
          </v-stepper-content>
          <v-stepper-content step="5">
            <fatturazione
              :ddt="ddtSelezionati"
              :clientiDdt="clientiSelezionati"
              :scontrini="scontriniSelezionati"
              :clientiScontrini="clientiScontriniSelezionati"
              :dateDdt="dateDdt"
              :dateScontrini="dateScontrini"
              @generazione-completa="openAnteprima"
            />
            <v-btn color="default" class="mr-5 mt-3" @click="stepper1 = 4"
              >Indietro</v-btn
            >
            <!-- <v-btn color="primary" class="mt-3" @click="openAnteprima">Anteprima</v-btn> -->
          </v-stepper-content>
          <v-stepper-content step="6">
            <anteprima
              :ddt="ddtSelezionati"
              @creazione-differite-completa="openDefinitive"
            />
            <v-btn color="default" class="mr-5 mt-3" @click="stepper1 = 5"
              >Indietro</v-btn
            >
            <!-- <v-btn color="primary" class="mt-3" @click="openDefinitive">Definitive</v-btn> -->
          </v-stepper-content>
          <v-stepper-content step="7">
            <definitive />
            <v-btn color="default" class="mr-5 mt-3" @click="stepper1 = 6"
              >Indietro</v-btn
            >
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
    <dialog-conferma
      :show="dialogConferma"
      :title="titoloConferma"
      :message="messaggioConferma"
      :onlyOk="onlyOk"
      :confirmText="confirmText"
      @dialog-confirm="onConferma"
      @dialog-cancel="
        dialogConferma = false;
        onlyOk = false;
      "
    />
  </v-dialog>
</template>

<script>
/* eslint-disable */
import DialogConferma from "@/components/dialogConferma";

import FiltriDdt from "./multiple/filtriDdt.vue";
import ClientiDdt from "./multiple/clientiDdt.vue";
import SceltaDdt from "./multiple/sceltaDdt.vue";
import FiltroScontrini from "./multiple/filtroScontrini.vue";
import SceltaScontrini from "./multiple/sceltaScontrini.vue";
import Fatturazione from "./multiple/fatturazione.vue";
import Anteprima from "./multiple/anteprima.vue";
import Definitive from "./multiple/definitive.vue";

import documenti from "@/services/documentiService.js";
import scontrini from "@/services/scontriniService.js";

export default {
  props: {
    showDialog: { type: Boolean, default: false },
  },
  components: {
    DialogConferma,
    FiltriDdt,
    ClientiDdt,
    SceltaDdt,
    FiltroScontrini,
    SceltaScontrini,
    Fatturazione,
    Anteprima,
    Definitive,
  },
  data(vm) {
    return {
      stepper1: 1,
      dialogCreazioniMultiple: false,
      dialogConferma: false,
      titoloConferma: "",
      messaggioConferma: "",
      onlyOk: false,
      onConferma: vm.operazioneEseguitaConfirm,
      confirmText: "SI",
      refreshTick: 0,
      filtri: null,
      idsClienti: [],
      totaleClienti: 0,
      idsClientiScontrini: [],
      clienti: [],
      selected: [],
      loading: true,
      options: {},
      headers: [
        { text: "Tipo", value: "tipoDocumento.descrizione", align: "start" },
        { text: "Numero", value: "_id" },
        { text: "Data", value: "data" },
        { text: "Nominativo", value: "c_nominativo" },
        { text: "Stato XML", value: "xml.stato" },
        { text: "Actions", value: "actions", sortable: false },
        { text: "", value: "data-table-expand" },
      ],
      expanded: [],
      singleExpand: false,
      clientiSelezionati: [],
      clientiScontriniSelezionati: [],
      bollettari: [],
      ddtSelezionati: [],
      scontriniSelezionati: [],
      dateDdt: null,
      dateScontrini: null,
      nonFatturate: true, // TODO: Aggiungere Switch per scegliere + evidenziare se già fatturata
    };
  },
  watch: {
    showDialog(value) {
      if (value) {
        this.stepper1 = 1;
        this.dialogCreazioniMultiple = value;
      }
    },
    options: {
      async handler() {
        // await this.getDataFromApi(this.filtri)
      },
      deep: true,
    },
    /*       async refreshList(value) {
        if (value) {
          await this.getDataFromApi(this.filtri)
        }
      }   */
  },
  mounted() {
    this.dialogCreazioniMultiple = this.showDialog;
  },
  computed: {
    altLabels() {
      return ["xs", "sm", "md"].includes(this.$vuetify.breakpoint.name);
    },
    /*       refreshList() {
        console.log('refreshList')
        return this.$store.getters['documenti/refreshTestata']
      }, */
    documentiSorted() {
      const els = this.documenti;
      const elSorted = els.sort(dynamicSortMultiple("_id"));
      return elSorted;
    },
  },
  methods: {
    async onRicercaClienti(filtri) {
      let filtri_ddt = { ...filtri };
      this.bollettari = filtri.bollettario;
      filtri_ddt.tipoDocumento = ["ddt"];
      // filtri_ddt.nonFatturata = this.nonFatturate
      filtri_ddt.nonFatturata = filtri_ddt.soloNonFatturate;
      await this.getDataClienti(filtri_ddt);
      this.dateDdt = {
        start: filtri.start,
        end: filtri.end,
        soloNonFatturate: filtri.soloNonFatturate,
      };
    },
    async getDataClienti(filtri) {
      if (!filtri) return;
      try {
        this.loading = true;
        let data = await documenti.getFilteredDocumentCustomers(
          filtri,
          this.options
        );
        const clientiRaw = data && data.total_rows > 0 ? data.rows : [];
        let ids = clientiRaw.map((x) => x.codice);
        ids = _.uniq(ids);
        // Object.assign(this.idsClienti, ids)
        this.idsClienti = ids;
        this.$store.commit("clienti/SET_REFRESH");
      } finally {
        this.loading = false;
      }
    },

    async onRicercaClientiScontrini(filtri) {
      await this.getDataClientiScontrini(filtri);
      this.dateScontrini = {
        start: filtri.start,
        end: filtri.end,
        soloNonFatturate: filtri.soloNonFatturate,
      };
    },
    async getDataClientiScontrini(filtri) {
      if (!filtri) return;
      try {
        this.loading = true;
        // deve prendere i clienti dagli scontrini di tipo segue fattura
        let data = await scontrini.getElencoClientiScontriniNonRiscosso(
          filtri,
          this.options
        );
        const clientiRaw = data && data.total_rows > 0 ? data.rows : [];
        const ids = clientiRaw.map((x) => x.codice);
        // Object.assign(this.idsClientiScontrini, ids)
        this.idsClientiScontrini = ids;
        this.$store.commit("clienti/SET_REFRESH");
      } finally {
        this.loading = false;
      }
    },
    operazioneEseguita() {
      this.titoloConferma = "Operazione eseguita";
      this.messaggioConferma = "Operazione eseguita con successo !";
      this.onlyOk = true;
      this.onConferma = this.operazioneEseguitaConfirm;
      this.confirmText = "OK";
      this.dialogConferma = true;
    },
    operazioneEseguitaConfirm() {
      this.dialogConferma = false;
      this.onlyOk = false;
      this.confirmText = "SI";
    },
    onAnnulla() {
      this.refreshTick++;
    },
    onClientiSelezionati(ids) {
      this.clientiSelezionati = ids;
    },
    onClientiScontriniSelezionati(ids) {
      this.clientiScontriniSelezionati = ids;
    },
    openSceltaDDT() {
      this.stepper1 = 2;
      this.$store.commit("documenti/SET_REFRESH", "multiple");
      // forza aggiornamento lista ddt
    },
    openSceltaScontrini() {
      this.stepper1 = 4;
      this.$store.commit("documenti/SET_REFRESH", "multipleScontrini");
      // forza aggiornamento lista scontrini
    },
    openAnteprima() {
      this.stepper1 = 6;
      this.$store.commit("documenti/SET_REFRESH", "proforma");
    },
    openDefinitive() {
      this.stepper1 = 7;
      this.$store.commit("documenti/SET_REFRESH", "definitive");
    },
    onDdtSelezionati(elenco) {
      this.ddtSelezionati = elenco;
    },
    onScontriniSelezionati(elenco) {
      this.scontriniSelezionati = elenco;
    },
  },
};
</script>
